export default __webpack_public_path__ + "static/media/Poppins-Light.fcc637c6.woff2";